/**
 * Horizontal page gutters for full-width coach shells (dashboard, offerings,
 * students, leads, facilities lists, schedule, coach profile overview):
 * 36px from sm up (≥600px, including iPad), 8px at down('xs') (<600px).
 * Full width — do not cap these pages at 832.
 * Constrained pages (settings, reviews, payments, account details) keep a
 * centered 832px column and should not use this helper.
 */
export const PAGE_CONTENT_GUTTER_SPACING = 4.5
export const PAGE_CONTENT_GUTTER_SPACING_SM = 1

export const pageContentHorizontalGutters = (theme, { sm, ...rest } = {}) => {
  const xsKey = theme.breakpoints.down('xs')
  const smKey = theme.breakpoints.down('sm')
  const { [xsKey]: restXs, [smKey]: restSm, ...restWithoutBreakpoints } = rest

  return {
    boxSizing: 'border-box',
    maxWidth: '100%',
    ...restWithoutBreakpoints,
    paddingLeft: theme.spacing(PAGE_CONTENT_GUTTER_SPACING),
    paddingRight: theme.spacing(PAGE_CONTENT_GUTTER_SPACING),
    ...(sm || restSm
      ? {
        [smKey]: {
          ...restSm,
          ...sm,
        },
      }
      : {}),
    [xsKey]: {
      ...restXs,
      paddingLeft: theme.spacing(PAGE_CONTENT_GUTTER_SPACING_SM),
      paddingRight: theme.spacing(PAGE_CONTENT_GUTTER_SPACING_SM),
    },
  }
}
